import { renderWithLoader } from '@meteor/data-hooks';
import { Button } from '@meteor/ui';
import { Table, TextField } from '@radix-ui/themes';
import { useState } from 'react';
import { adminsState } from '../../state';

export let AdminsPage = () => {
  let [after, setAfter] = useState<string | undefined>();
  let [search, setSearch] = useState<string | undefined>();

  let admins = adminsState.use({
    search,
    after
  });

  return renderWithLoader({ admins })(({ admins }) => (
    <>
      <form
        style={{ marginBottom: 20 }}
        onSubmit={e => {
          e.preventDefault();
          let formData = new FormData(e.target as HTMLFormElement);
          let search = formData.get('search') as string;
          setSearch(search);
        }}
      >
        <TextField.Root
          placeholder="Search"
          name="search"
          defaultValue={search}
        ></TextField.Root>
      </form>

      <Table.Root variant="surface">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Email</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Created At</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell></Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {admins.data.map(invite => (
            <Table.Row key={invite.id}>
              <Table.Cell>{invite.name}</Table.Cell>
              <Table.Cell>{invite.email}</Table.Cell>
              <Table.Cell>{invite.createdAt.toLocaleDateString('de-at')}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

      <Button
        size="1"
        style={{ marginTop: 20 }}
        onClick={() => setAfter(admins.data[admins.data.length - 1]?.id)}
      >
        Load More
      </Button>
    </>
  ));
};
